import { createApiCall } from 'lib/base';
import { generateEndpoint } from '@ngtrvu/use-api';

const FETCH_BANK_BRANCH_LIST_API_ID = 'INVESTCORE/FETCH_BANK_BRANCH';

const apiCall = createApiCall(
  FETCH_BANK_BRANCH_LIST_API_ID,
  ({ id }) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/banks/${id}/branches`,
    }),
    method: 'GET',
  })
);

export default apiCall;
